var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-table"},[(_vm.mobileView)?_c('mobile-content'):_vm._e(),(!_vm.mobileView)?_c('Aside'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }